var $f1d861a9af53b27d$exports = {};
$f1d861a9af53b27d$exports = {
    "backButton": (args)=>`Vend tilbage til ${args.prevMenuButton}`,
    "moreActions": `Flere handlinger`,
    "unavailable": `Ikke tilg\xe6ngelig, udvid for detaljer`
};


export {$f1d861a9af53b27d$exports as default};
//# sourceMappingURL=da-DK.mjs.map
